import React from 'react'
import PropTypes from 'prop-types'
import { useLocation, useHistory } from 'react-router-dom'
import { Text } from 'shared/components'
import CustomIcon from 'shared/components/customIcon'
import { event, profile } from 'routes/route.map'

import * as styles from './styles'

const navigationItems = [
	{
		id: 'tournaments',
		label: 'Tournaments',
		icon: 'event',
		path: event.index(),
		activePattern: /^\/main\/events/,
	},
	{
		id: 'beneficiaries',
		label: 'Beneficiaries',
		icon: 'profile',
		path: profile.beneficiaries(),
		activePattern: /^\/profile\/beneficiaries/,
	},
	{
		id: 'history',
		label: 'History',
		icon: 'history',
		path: profile.inwins(),
		activePattern: /^\/profile\/inwins/,
	},
	{
		id: 'profile',
		label: 'Profile',
		icon: 'profile',
		path: profile.index(),
		activePattern: /^\/profile(?!\/)/,
	},
]

const BottomNavigationComponent = () => {
	const location = useLocation()
	const history = useHistory()

	const handleNavigation = (path) => {
		history.push(path)
	}

	return (
		<nav css={styles.bottomNav}>
			<div css={styles.navContainer}>
				{navigationItems.map((item) => {
					const isActive = item.activePattern.test(location.pathname)

					return (
						<button
							key={item.id}
							css={[styles.navItem, isActive && styles.navItemActive]}
							onClick={() => handleNavigation(item.path)}
							type="button"
						>
							<div css={styles.iconContainer}>
								<CustomIcon
									icon={item.icon}
									css={[
										isActive ? styles.navIconActive : styles.navIcon,
										item.icon === 'event' && styles.eventIconLarger
									]}
								/>
							</div>
							<Text
								size={12}
								medium
								css={[styles.navLabel, isActive && styles.navLabelActive]}
							>
								{item.label}
							</Text>
						</button>
					)
				})}
			</div>
		</nav>
	)
}

BottomNavigationComponent.propTypes = {}

export default BottomNavigationComponent 